import { PulseLoader } from "react-spinners";

export const TableInfo = ({ sx }) => (
  <p
    className="user_datatable_loading"
    style={{ height: "min-content", ...sx }}
  >
    Buscando Informações...
    <PulseLoader color="#1361A4" className="user_datatable_loader" />
  </p>
);
